// business 业务组件
import BFilterLeft from './business/b-filter-left'
import BDetailNav from './business/b-detail-nav'
import BPopupAccount from './business/b-popup-account'
import BDetailProcess from './business/b-detail-process'
import BDetailStep from './business/b-detail-step'
import BGoodsCategory from './business/b-goods-category/index'
import BGoodsTexture from './business/b-goods-texture'
import BOrganizeDepartment from './business/b-organize-department/index'
import BOrganizeStaff from './business/b-organize-staff/index'
import BPopupCustomer from './business/b-popup-customer'
import BPopupParentCode from './business/b-popup-parent-code'
import BPopupProcessStep from './business/b-popup-process-step'
import BPopupTest from './business/b-popup-test'
import BPopupVerifyGoodsDetail from './business/b-popup-verify-goods-detail/index'
import BPopupVerifyGoodsEdit from './business/b-popup-verify-goods-edit/index'
import BPopupVerifyGoodsView from './business/b-popup-verify-goods-view/index'
import BPopupChooseMuBan from './business/b-popup-choose-mu-ban'
import BPopupChooseShangPin from './business/b-popup-choose-shang-pin'

// common 公用组件
import CListEmpty from './common/c-list-empty'
import CBack from './common/c-back'
import CTableHeader from './common/c-table-header'
import CCascaderCategory from './common/c-cascader-category'
import CCascaderAddress from './common/c-cascader-address'
import CCascaderIndustryCategory from './common/c-cascader-industry-category'
import CCascaderDepartmentMember from './common/c-cascader-department-member'
import CReadCompanyAddress from './common/c-read-company-address'

// element-ul 封装组件
import EDrawer from './element-ui/e-drawer'
import ETabs from './element-ui/e-tabs'
import EForm from './element-ui/e-form'
import EDatePicker from './element-ui/e-date-picker'
import EUploadFile from './element-ui/e-upload-file'
import EUploadImage from './element-ui/e-upload-image'
import ESelectArray from './element-ui/e-select-array'

const components = [
  // b-xxx
  ['b-filter-left', BFilterLeft],
  ['b-detail-nav', BDetailNav],
  ['b-popup-account', BPopupAccount],
  ['b-detail-process', BDetailProcess],
  ['b-detail-step', BDetailStep],
  ['b-goods-category', BGoodsCategory],
  ['b-goods-texture', BGoodsTexture],
  ['b-organize-department', BOrganizeDepartment],
  ['b-organize-staff', BOrganizeStaff],
  ['b-popup-customer', BPopupCustomer],
  ['b-popup-parent-code', BPopupParentCode],
  ['b-popup-process-step', BPopupProcessStep],
  ['b-popup-test', BPopupTest],
  ['b-popup-verify-goods-detail', BPopupVerifyGoodsDetail],
  ['b-popup-verify-goods-edit', BPopupVerifyGoodsEdit],
  ['b-popup-verify-goods-view', BPopupVerifyGoodsView],
  ['b-popup-choose-mu-ban', BPopupChooseMuBan],
  ['b-popup-choose-shang-pin', BPopupChooseShangPin],

  // c-xxx
  ['c-list-empty', CListEmpty],
  ['c-back', CBack],
  ['c-table-header', CTableHeader],
  ['c-cascader-category', CCascaderCategory],
  ['c-cascader-address', CCascaderAddress],
  ['c-cascader-industry-category', CCascaderIndustryCategory],
  ['c-cascader-department-member', CCascaderDepartmentMember],
  ['c-read-company-address', CReadCompanyAddress],

  // e-xxx
  ['e-drawer', EDrawer],
  ['e-tabs', ETabs],
  ['e-form', EForm],
  ['e-date-picker', EDatePicker],
  ['e-upload-file', EUploadFile],
  ['e-upload-image', EUploadImage],
  ['e-select-array', ESelectArray]
]

const setComponents = (app) => {
  components.forEach((item) => {
    app.use({
      install(app) {
        app.component(item[0], item[1])
      }
    })
  })
}

export default setComponents
